import React from 'react'
import Sidebar from './Sidebar/Sidebar'
import Header from './Header/Header'
import "./Layout.css"
import { useSelector } from 'react-redux'

const Layout = (props) => {
  const isLogin = useSelector((state) => state.login.isLogin);
  return (
    <div className='layout'>
        <Sidebar />
        <div className={`main-section ${isLogin ? 'main-sectionSpacing' : ''}`}>
            <Header />
            <main className={`main ${isLogin ? "mainLogin" : ""}`}>{props.children}</main>
        </div>
    </div>
  )
}

export default Layout